export const enum ETranslations {
  en = 'en',
  es = 'es',
}

export enum ETranslationsTitle {
  'en' = 'English',
  'es' = 'Spanish',
}
